<template>
  <div>
    <OrderExcel :typeExcel="2" />
  </div>
</template>

<script>
import OrderExcel from "./OrderExcel.vue";
export default {
  data() {
    return {};
  },
  components: { OrderExcel },
};
</script>
